import wysiwyg from 'vue-wysiwyg'

const wysiwygConfig = {
  hideModules: {
    'separator': true,
    'table': true,
    'code': true,
    'image': true,
    'link': true,
    'headings': true
  }
}

export { wysiwyg, wysiwygConfig }



// WEBPACK FOOTER //
// ./src/wysiwyg/index.js